import { render } from "./login-template.vue?vue&type=template&id=1e6edff1&scoped=true"
import script from "./login-template.vue?vue&type=script&lang=js"
export * from "./login-template.vue?vue&type=script&lang=js"

import "./login-template.vue?vue&type=style&index=0&id=1e6edff1&scoped=true&lang=less"
script.render = render
script.__scopeId = "data-v-1e6edff1"

export default script